module.exports = __webpack_public_path__ + "media/svg-new/tick 1-fedafc9b.svg";